module.exports = __webpack_public_path__ + "assets/841d2453cdb955fd46fe51f030bfbe83.png";